module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAECAYAAAANt+ToAAAAJ0lEQVRIie3SMQEAAAiEwNf+nTHGO3AJGBiASGXbDpASR9QTjqgXDpKGBAR2fgLHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/nav/line.png
// module id = ng6J
// module chunks = 1